import { useSession } from "hooks/useSession";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import { fetchWrapper } from "utils/apiFetch";
import { showMainToast } from "utils/showToast";
import FullscreenModal from "./components/FullScreenModal";
import RegisterKYCModalBody from "./components/RegisterBankKYCModalComponent";
import { RegisterKYCModalFooter } from "./components/ModalFooterKYC";
import useLocationService from "hooks/useLocationService";
import { method } from "lodash";

function MainAEPSPage() {
  const {
    location,

    permission,
    getLocation,
    checkPermission,
  } = useLocationService(true);
  const { name, userid, role } = useSession();
  const [data, setData] = useState(null); // to store API data
  const [loading, setLoading] = useState(true); // to manage loader
  const [error, setError] = useState(null); // to handle errors
  const navigate = useNavigate()
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});

  const handleFormChange = (data) => setFormData(data);

  const handleSubmit = (data) => {
    console.log("Form submitted:", data);
    // TODO: Call your KYC register API here
  };
  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await fetchWrapper(
        `https://api.mokshiq.in/get_user_profile?user=${userid}`
      );

      setData(response.data);
    } catch (err) {
      showMainToast(err.message, 'danger');
    } finally {
      setLoading(false); // hide loader
    }
  };
  useEffect(() => {
    getLocation();

    fetchData();
  }, []);


  const closeModalAlways = () => {
    const modalEl = document.getElementById("modalAlwaysFullscreen");
    if (modalEl) {
      const modalInstance = window.bootstrap.Modal.getInstance(modalEl);
      if (modalInstance) modalInstance.hide();
    }
  };


  const onboardingPS = async () => {
    try {
      setLoading(true);
      const formData = new FormData();
      // formData.append("userid", "3");
      const result = await fetchWrapper(
        `https://api.mokshiq.in/aeps_onboarding?userid=${userid}`
      );

      if (result.status && result.data.onboard_pending === 0) {
        showMainToast(result.data.message, "success");
      } else if (result.status && result.data.hasOwnProperty("redirecturl") && result.data.redirecturl) {
        window.open(result.data.redirecturl, "_blank", "noopener,noreferrer");
      }

      else {
        setError(result.data.message);
      }
      // setData(result.data);
    } catch (err) {
      showMainToast(err.message, "danger");
    } finally {
      setLoading(false); // hide loader
    }

  }

  const checkSoftmintKYC = async () => { 
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("userid", userid);
      formData.append("platform", "WEB");
      const result = await fetchWrapper(
        `https://api.mokshiq.in/soft_two_factor_status`,
        {
          method: "POST",
          body: formData
        }
      );

      if (!result.status) {
        showMainToast(result.data, "danger");
        window.open(result.new_data.data);
      } else if (result.status) {
       navigate("/aeps_service_2");
       showMainToast(result.data, "success");
      }

      else {
        setError(result.data.message);
      }
      // setData(result.data);
    } catch (err) {
      showMainToast(err.message, "danger");
    } finally {
      setLoading(false); // hide loader
    }
    }
  const updateMaplocation = async () => {
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("userid", userid);
      formData.append("transection_platform", "WEB");
      formData.append("lat", location.lat);
      formData.append("long", location.lng);
      const result = await fetchWrapper(
        `https://api.mokshiq.in/merchant_location_update`,
        {
          method: "POST",
          body: formData
        }
      );

      if (result.status) {
        showMainToast(result.message, "success");
        fetchData();
      }

      else {
        setError(result.message);
      }
      // setData(result.data);
    } catch (err) {
      showMainToast(err.message, "danger");
    } finally {
      setLoading(false); // hide loader
    }

  }

  return (
    <main>
      <div className="container-fluid ui-section">
        <div className="row m-1">
          <div className="col-12 ">
            <h4 className="main-title">AEPS Service</h4>
            <ul className="app-line-breadcrumbs mb-3">
              <li>
                <a className="f-s-14 f-w-500" href="#">
                  <span>
                    <i className="ph-duotone ph-briefcase-metal f-s-16"></i>{" "}
                    Services
                  </span>
                </a>
              </li>
              <li className="active">
                <a className="f-s-14 f-w-500" href="#">
                  AEPS
                </a>
              </li>
            </ul>
          </div>
        </div>

        {loading ? (
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  <div className="loader-container">
                    <div className="loader-main">
                      <div className="loader_box">
                        <div className="loader_16"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="row">
            {/* ✅ Three condition cases */}
            {data?.paeps_onboarding === true &&
              data?.paeps_reg_bank2 === true && data?.paeps_auth_bank2 === true ? (
              <div className="col-sm-12 col-md-12 col-xl-8">
                <div className="row">
                  <div className="col-sm-12 col-md-6 col-xl-6">
                    {data?.gst_num === "123" ? (
                      <div className="card">
                        <div className="card-header">
                          <h5>Quick AEPS</h5>
                          <p className="mb-0 text-secondary">
                            Updte your shop lcation
                          </p>
                        </div>
                        <div className="card-body">
                          <button className="btn btn-primary btn-md" type="button" onClick={updateMaplocation}>
                            Update Map Location
                          </button>
                        </div>
                      </div>) : (<div className="card">
                        <div className="card-header">
                          <h5>Quick AEPS</h5>
                          <p className="mb-0 text-secondary">
                            Auth Bank KYC already completed ✅
                          </p>
                        </div>
                        <div className="card-body">
                          <button className="btn btn-primary btn-md" type="button" onClick={() => { window.location.href = "/aeps_service" }}>
                            Start Transection
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="col-sm-12 col-md-6 col-xl-6">
                    <div className="card">
                      <div className="card-header">
                        <h5>Quick AadharPay</h5>
                        <p className="mb-0 text-secondary">
                          Auth Bank KYC already completed ✅
                        </p>
                      </div>
                      <div className="card-body">
                        <button className="btn btn-primary btn-md" type="button" onClick={() => { window.location.href = "/aadharpay_service" }}>
                          Start Aadhar Pay
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : data?.paeps_onboarding === true &&
              data?.paeps_reg_bank2 === true ? (
              <div className="col-sm-12 col-md-6 col-xl-4">
                <div className="card">
                  <div className="card-header">
                    <h5>Quick AEPS</h5>
                    <p className="mb-0 text-secondary">
                      Please inititae with Auth KYC
                    </p>
                  </div>
                  <div className="card-body">
                    <button className="btn btn-warning btn-md" type="button" data-bs-toggle="modal"
                      data-bs-target="#modalAlwaysFullscreen">
                      Start Auth KYC
                    </button>
                  </div>
                </div>
              </div>
            ) : data?.paeps_onboarding === true &&
              data?.paeps_reg_bank2 === false ? (
              <div className="col-sm-12 col-md-6 col-xl-4">
                <div className="card">
                  <div className="card-header">
                    <h5>Quick AEPS</h5>
                    <p className="mb-0 text-secondary">
                      Please inititate onboarding with bank.
                    </p>
                  </div>
                  <div className="card-body">
                    <button className="btn btn-warning btn-md" type="button" data-bs-toggle="modal"
                      data-bs-target="#modalAlwaysFullscreen">
                      Register Bank KYC
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              <div className="col-sm-12 col-md-6 col-xl-4">
                <div className="card">
                  <div className="card-header">
                    <h5>Quick AEPS</h5>
                    <p className="mb-0 text-secondary">
                      Submit KYC – Aadhaar, PAN, and Bank details.
                    </p>
                  </div>
                  <div className="card-body">
                    <button
                      className="btn btn-light-primary btn-md"
                      type="button" onClick={onboardingPS}
                    >
                      Start Onboarding
                    </button>
                  </div>
                </div>
              </div>
            )}

            {/* Instant AEPS (always visible) */}
            {data?.outlet_id !== null &&
              data?.outlet_id !== "" &&
              data?.outlet_id !== undefined ? (<div className="col-sm-12 col-md-6 col-xl-4">
                <div className="card">
                  <div className="card-header">
                    <h5>Instant AEPS KYC</h5>
                    <p className="mb-0 text-secondary">
                      Check AEPS KYC.
                    </p>
                  </div>
                  <div className="card-body">
                    <button
                      className="btn btn-light-primary btn-md"
                      id="click_1"
                      type="button" onClick={checkSoftmintKYC}
                    >
                      Check KYC
                    </button>
                  </div>
                </div>
              </div>
            ) : (<div className="col-sm-12 col-md-6 col-xl-4">
              <div className="card">
                <div className="card-header">
                  <h5>Instant AEPS</h5>
                  <p className="mb-0 text-secondary">
                    Submit KYC – Upload Aadhaar, PAN, and Bank details.

                  </p>
                </div>
                <div className="card-body">
                  <button
                    className="btn btn-light-primary btn-md"
                    id="click_1"
                    type="button"
                  >
                    Start Onboarding
                  </button>
                </div>
              </div>
            </div>)}

            {/* E AEPS (always visible) */}
            <div className="col-sm-12 col-md-6 col-xl-4">
              <div className="card">
                <div className="card-header">
                  <h5>E AEPS</h5>
                  <p className="mb-0 text-secondary">
                    Submit KYC – Upload Aadhaar, PAN, and Bank details.
                  </p>
                </div>
                <div className="card-body">
                  <button
                    className="btn btn-light-primary btn-md"
                    id="click_1"
                    type="button"
                  >
                    Start Onboarding
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <FullscreenModal
        id="modalAlwaysFullscreen"
        title="Register KYC"
        BodyComponent={() => (
          <RegisterKYCModalBody onFormChange={handleFormChange} errors={errors} onSuccess={fetchData} />
        )}
        FooterComponent={() => (
          <RegisterKYCModalFooter
            onSubmit={handleSubmit}
            formData={formData}
            onSuccessClose={closeModalAlways}
          />

        )}

        size="lg"
      />
    </main>
  );

}

export default MainAEPSPage;
